import { useState } from "react";
import "./style.scss";

export default function Image({ src = "", alt = "" }) {
  const [isError, setIsError] = useState(false);

  if (isError) {
    return (
      <div className="avatar-container">{alt.slice(0, 1).toUpperCase()}</div>
    );
  }
  return (
    <img
      className="avatar"
      {...{ src, alt }}
      onError={(e) => setIsError(true)}
    />
  );
}
